import { IonCard, IonCardContent, IonContent, IonPage } from '@ionic/react';
import { useEffect } from 'react';
import { useHistory } from 'react-router';

import LayoutGap from '../../../layouts/LayoutGap';
import Toolbar from '../../../layouts/Toolbar';
import { baseUrl } from '../../../library/Funcs';

import './Map.css';

const Map: React.FC = () => {
    const history = useHistory();

    useEffect(() => {
        const campaignClick = (e: any) => {
            const data = e.data;
            let id = 0;

            if (data.type! == "campaign") {
                id = data?.id;
            }

            history.push("/map/campaign/" + id);
        }

        window.addEventListener('message', campaignClick);

        return () => {
            window.removeEventListener('message', campaignClick);
        }
    }, [])

    return <IonPage className="map">
        <Toolbar title="نقشه پروژه ها" hasBackButton />

        <LayoutGap />

        <IonContent className="main-content">
            <IonCard>
                <IonCardContent>
                    <div className="iframe-wrapper">
                        <iframe className="map-frame" src={baseUrl + "/full-map"} />
                    </div>
                </IonCardContent>
            </IonCard>
        </IonContent>
    </IonPage>
}

export default Map